var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.tags && _setup.props.tags.length)?_c('div',{staticClass:"d-flex flex-wrap mt-1"},_vm._l((_setup.props.tags),function(tag){return _c(_setup.BBadge,{key:tag,staticClass:"mr-1 mb-1",attrs:{"variant":"light-primary"}},[_vm._v(" "+_vm._s(_setup.getTagLabel(tag))+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }